import React from 'react';
import ProfileLayout from '../../../layout/profile';
import ClientTelephonesById from './ClientTelephonesById';

export default function Telephones () {
    return (
        <ProfileLayout>
            <ClientTelephonesById />
        </ProfileLayout>
    );
}
